module.exports = __webpack_public_path__ + "img/team-product.9c536bdd.svg";